import React, { Component } from 'react';
import EditEmployeeForm from './EditEmployeeForm'
import {Row , Col} from 'antd'

class EditEmployee extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    render() { 
        return (
         
            <Row>
                <Col span={14} >
                    <EditEmployeeForm {...this.props}/>
                </Col>       
            </Row>  
        );
    }
}
 
export default EditEmployee;